// import { initializeApp } from "firebase/app";
// import { getDatabase, ref, push, onValue, serverTimestamp, set } from "firebase/database";
// import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
// import * as ChatActions from '../../redux/actions/chatAction';
// import SocketService from "../../utils/services/socket-service";
// import { toaster } from "../../utils/services/toast-service";

// const firebaseConfig = {
//   apiKey: "AIzaSyDpFoGJ0glT_V8Qy2ybG4uhbX6KI0Plv20",
//   authDomain: "astrobook-f654b.firebaseapp.com",
//   databaseURL: "https://astrobook-f654b-default-rtdb.firebaseio.com",
//   projectId: "astrobook-f654b",
//   storageBucket: "astrobook-f654b.firebasestorage.app",
//   messagingSenderId: "87240796994",
//   appId: "1:87240796994:web:f67a36c9d8d5ec142836db",
// };

// //! Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const database = getDatabase(app);

// //! Initialize Firebase Cloud Messaging and get a reference to the service
// let messaging = getMessaging(app);

// const generateTokenByRequestPermission = async () => {
//   try {
//     const permission = await Notification.requestPermission()
//     if (permission === 'granted') {
//       const fcm_token = await getToken(messaging, { vapidKey: 'BBzBhTiXJKaO3_Mgx09eqnsknn4U5YN8m9jtkG3l-9oslw1ATYQnWp21Zq7WT0aJswARr9WZo6plh9PJHVMTANM' });
//       console.log('FCM Token', fcm_token);
//       localStorage.setItem('fcm_token', fcm_token);
//       return fcm_token;
//     } else if (permission === 'denied') {
//     }
//     // return 'fcm_token';
//   } catch (error) {
//     console.log(error)
//   }
// };

// //! Handle foreground messages
// const onMessageListener = async (navigate, dispatch) => {
//   const supported = await isSupported();

//   if (!supported) {
//     console.warn("Firebase Messaging not supported in this environment.");
//     return;
//   }

//   onMessage(messaging, async (payload) => {
//     // console.log('Message received. ', payload);
//     const notificationOptions = { data: payload.data, title: payload.data.title };
//     console.log("Notification Option :: ", notificationOptions);

//     const notificationData = notificationOptions.data;
//     console.log("Notification Data :: ", notificationData);
//     console.log('Profile Id ::: ', notificationData?.profileId);

//     if (notificationData?.type == 'chat_declined') {
//       // new Notification(notificationOptions?.title);
//       toaster?.info({ text: notificationOptions?.title });

//       localStorage?.removeItem('requestInitiatedByCustomerTimer');
//       localStorage?.removeItem('requestInitiatedByCustomerData');
//       localStorage?.removeItem('requestInitiatedByCustomerInitiated');
//       dispatch(ChatActions?.requestInitiatedByCustomer({ initiated: false, timer: 60, astrologerData: null }));
//       dispatch(ChatActions?.hideChatMessageInputField(false));

//     } else if (notificationData?.type == 'call_invoice') {
//       dispatch(ChatActions?.setCallInvoiceVisibility(true));
//       dispatch(ChatActions?.setCallInvoiceData(JSON.parse(notificationData?.data)));
//     } else {
//       let url;
//       switch (notificationData?.sent_to) {
//         case 'astrologer':
//           console.log('For Astrologer', notificationData?.sent_to)
//           url = `/chat/astrologer-accept-reject?user_id=${notificationData.user_id}&astroID=${notificationData.astroID}&chatId=${notificationData.chatId}&customerName=${notificationData.customerName}&astrologerName=${notificationData.astrologerName}&invoiceId=${notificationData.invoiceId}&priority=${notificationData.priority}&profileId=${notificationData.profileId}&type=${notificationData.type}&wallet_balance=${notificationData.wallet_balance}&welcome_message=${notificationData?.message}&customerImage=${notificationData.customerImage}&astrologerImage=${notificationData.astrologerImage}`;
//           navigate(url, '_blank');
//           localStorage?.setItem('rejectChatByAstrologerTimer', 60);
//           dispatch(ChatActions?.rejectChatByAstrologer({ rejected: false, timer: 60 }));
//           // console.log('Url ::: ', url);
//           break;

//         case 'customer':
//           console.log('For Customer', notificationData?.sent_to)

//           navigate(`/chat?customer=${notificationData.user_id}&astrologer=${notificationData.astroID}&chatId=${notificationData?.chatId}&profileId=${notificationData?.profileId || "67ebbdaf8bc2fa603ca7ec5a"}`, { replace: true })
//           localStorage?.removeItem('requestInitiatedByCustomerTimer');
//           localStorage?.removeItem('requestInitiatedByCustomerData');
//           localStorage?.removeItem('requestInitiatedByCustomerInitiated');
//           dispatch(ChatActions?.requestInitiatedByCustomer({ initiated: false, timer: 60, astrologerData: null }));
//           dispatch(ChatActions?.hideChatMessageInputField(false));
//           console.log(`SocketService.emit('startChatTimer', notificationData?.roomID);`)
//           //! New Logic
//           // dispatch(ConversationActions?.setChatRoomData(notificationData));
//           localStorage.setItem('chatId', notificationData?.chatId);
//           SocketService.emit('joinChatRoom', notificationData?.chatId);
//           SocketService.emit('startChatTimer', notificationData?.chatId);
//           break;

//         default:
//           break
//       }
//     }
//   });
// };

// export { database, ref, push, onValue, serverTimestamp, set, generateTokenByRequestPermission, messaging, onMessageListener };

import { initializeApp } from "firebase/app";
import {
  getDatabase, ref, push, onValue, serverTimestamp, set
} from "firebase/database";
import {
  getMessaging, getToken, isSupported, onMessage
} from "firebase/messaging";

import * as ChatActions from '../../redux/actions/chatAction';
import SocketService from "../../utils/services/socket-service";
import { toaster } from "../../utils/services/toast-service";

const firebaseConfig = {
  apiKey: "AIzaSyDpFoGJ0glT_V8Qy2ybG4uhbX6KI0Plv20",
  authDomain: "astrobook-f654b.firebaseapp.com",
  databaseURL: "https://astrobook-f654b-default-rtdb.firebaseio.com",
  projectId: "astrobook-f654b",
  storageBucket: "astrobook-f654b.firebasestorage.app",
  messagingSenderId: "87240796994",
  appId: "1:87240796994:web:f67a36c9d8d5ec142836db",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Declare messaging but initialize later
let messaging;

// Check if messaging is supported before using it
const initFirebaseMessaging = async () => {
  const supported = await isSupported();
  if (supported && 'Notification' in window && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
    return messaging;
  } else {
    console.warn('Firebase messaging not supported in this environment.');
    return null;
  }
};

const generateTokenByRequestPermission = async () => {
  const msg = await initFirebaseMessaging();
  if (!msg) return;

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const fcm_token = await getToken(msg, {
        vapidKey: 'BBzBhTiXJKaO3_Mgx09eqnsknn4U5YN8m9jtkG3l-9oslw1ATYQnWp21Zq7WT0aJswARr9WZo6plh9PJHVMTANM'
      });
      console.log('FCM Token', fcm_token);
      localStorage.setItem('fcm_token', fcm_token);
      return fcm_token;
    } else {
      console.log('Notification permission denied.');
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
  }
};

const onMessageListener = async (navigate, dispatch) => {
  const msg = await initFirebaseMessaging();
  if (!msg) return;

  onMessage(msg, async (payload) => {
    const notificationOptions = {
      data: payload.data,
      title: payload.data.title
    };

    const notificationData = notificationOptions.data;

    if (notificationData?.type === 'chat_declined') {
      toaster?.info({ text: notificationOptions?.title });
      localStorage?.removeItem('requestInitiatedByCustomerTimer');
      localStorage?.removeItem('requestInitiatedByCustomerData');
      localStorage?.removeItem('requestInitiatedByCustomerInitiated');
      dispatch(ChatActions?.requestInitiatedByCustomer({ initiated: false, timer: 60, astrologerData: null }));
      dispatch(ChatActions?.hideChatMessageInputField(false));

    } else if (notificationData?.type === 'call_invoice') {
      dispatch(ChatActions?.setCallInvoiceVisibility(true));
      dispatch(ChatActions?.setCallInvoiceData(JSON.parse(notificationData?.data)));

    } else {
      let url;
      switch (notificationData?.sent_to) {
        case 'astrologer':
          url = `/chat/astrologer-accept-reject?user_id=${notificationData.user_id}&astroID=${notificationData.astroID}&chatId=${notificationData.chatId}&customerName=${notificationData.customerName}&astrologerName=${notificationData.astrologerName}&invoiceId=${notificationData.invoiceId}&priority=${notificationData.priority}&profileId=${notificationData.profileId}&type=${notificationData.type}&wallet_balance=${notificationData.wallet_balance}&welcome_message=${notificationData?.message}&customerImage=${notificationData.customerImage}&astrologerImage=${notificationData.astrologerImage}`;
          navigate(url, '_blank');
          localStorage?.setItem('rejectChatByAstrologerTimer', 60);
          dispatch(ChatActions?.rejectChatByAstrologer({ rejected: false, timer: 60 }));
          break;

        case 'customer':
          navigate(`/chat?customer=${notificationData.user_id}&astrologer=${notificationData.astroID}&chatId=${notificationData?.chatId}&profileId=${notificationData?.profileId || "67ebbdaf8bc2fa603ca7ec5a"}`, { replace: true });
          localStorage?.removeItem('requestInitiatedByCustomerTimer');
          localStorage?.removeItem('requestInitiatedByCustomerData');
          localStorage?.removeItem('requestInitiatedByCustomerInitiated');
          dispatch(ChatActions?.requestInitiatedByCustomer({ initiated: false, timer: 60, astrologerData: null }));
          dispatch(ChatActions?.hideChatMessageInputField(false));
          localStorage.setItem('chatId', notificationData?.chatId);
          SocketService.emit('joinChatRoom', notificationData?.chatId);
          SocketService.emit('startChatTimer', notificationData?.chatId);
          break;
      }
    }
  });
};

export {
  database, ref, push, onValue, serverTimestamp, set,
  generateTokenByRequestPermission,
  onMessageListener
};
